export const SESSIONS_COLUMNS = [
  {
    sortKey: "alias",
    title: "Jugador",
  },
  {
    sortKey: "containerNumber",
    title: "Contenedor",
  },
  {
    sortKey: "headsetNumber",
    title: "Casco",
  },
  {
    sortKey: "isActive",
    title: "Estado del casco",
  },
  {
    sortKey: "",
    title: " ",
  },
];
